module.exports = __webpack_public_path__ + "img/1.43faf2d0.png";